module.exports = __webpack_public_path__ + "static/media/outros.407c1d40.png";